import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';

import { DiscountThemeService } from '../../services/discount-theme.service';

@Component({
  standalone: true,
  selector: 'ui-discount-badge',
  imports: [CommonModule],
  templateUrl: './ui-discount-badge.component.html',
  styleUrls: ['./ui-discount-badge.component.scss'],
})
export class UiDiscountBadgeComponent {
  @Input() value: number;

  protected discountTheme = inject(DiscountThemeService);
}
